import { AppAntSwitch } from "@components";
import React from "react";
import {tableHideDetails} from "../../../@signals";

export default function ToggleTableDetails() {

    return <AppAntSwitch
        falseText="Show details"
        trueText="Hide details"
        checked={tableHideDetails.value}
        onChange={() => tableHideDetails.value = !tableHideDetails.value}
    />
}